import React from "react";
import Navbar from "./Navbar";
import NavBottom from "./NavBottom";

const Contact = () => {
    return (
        <>
            <Navbar />
            <div className="contact-alls">
                <div className="contact-wrap">
                    <div className="contact-text">
                        <h2 className="contact-title">Contact</h2>
                        <p>
                            For questions, suggestions or requests, contact me by email below or contact my pages on social networks.
                        </p>
                        <a href="mailto:rustamovistam919@gmail.com">rustamovistam919@gmail.com <span><i class="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                    <div className="contact-me">
                        <div className="email-send">
                            <form action="mailto:rustamovistam919@gmail.com" method="post">
                                <label htmlFor="username">Name:</label>
                                <input type="text" name="username" id="in-name" required />
                                <label htmlFor="useremail">Email:</label>
                                <input type="email" name="useremail" id="in-email" required />
                                <label htmlFor="msg-text">Write message:</label>
                                <textarea name="msg-text" id="in-text" cols="30" rows="10" required></textarea>
                                <button className="send-button" type="submit">Send message</button>
                            </form>
                        </div>
                    </div>

                </div>
                    <div className="socials">
                        <a href="https://t.me/rustamovistam">
                            <i class="fa-brands fa-telegram"></i>
                            Telegram
                        </a>
                        <a href="https://instagram.com/a.i.rustamov?igshid=ZDdkNTZiNTM=">
                            <i class="fa-brands fa-instagram"></i>
                            Instagram
                        </a>
                        <a href="https://www.facebook.com/profile.php?id=100078858935083&mibextid=ZbWKwL">
                            <i class="fa-brands fa-facebook"></i>
                            Facebook
                        </a>
                        <a href="https://discordapp.com/users/istam003#1924">
                            <i class="fa-brands fa-discord"></i>
                            Discord
                        </a>
                        <a href="https://www.reddit.com/u/RustamovIstam?utm_medium=android_app&utm_source=share">
                            <i class="fa-brands fa-reddit"></i>
                            Reddit
                        </a>
                    </div>
            </div>
            <NavBottom />
        </>
    );
}

export default Contact;